import { useLanguage } from "@/i18n";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="relative overflow-hidden" data-testid="main-footer">
      <div className="px-5 md:px-10 pt-20 md:pt-32 flex flex-col md:flex-row justify-between gap-10 font-mono text-xs tracking-widest text-white/50">
        <div data-testid="footer-brand">
          <div className="flex items-center gap-3 mb-4">
            <img src="/assets/paq-logo-light.webp" alt="PAQ" className="h-6 w-auto" />
            <span>{t.footer.tagline.toUpperCase()}</span>
          </div>
          <address className="not-italic space-y-1.5 text-white/40 leading-relaxed" data-testid="footer-company-data">
            <p className="text-white/60">{t.footer.company}</p>
            <p>{t.footer.address}</p>
            <p>{t.footer.vat}</p>
            <p>{t.footer.capital}</p>
          </address>
        </div>
        <nav className="flex flex-wrap gap-6" data-testid="footer-nav">
          <a href="#tecnologia" className="hover:text-thermal transition-colors duration-300" data-testid="footer-nav-tech">{t.nav.tech.toUpperCase()}</a>
          <a href="#numeri" className="hover:text-thermal transition-colors duration-300" data-testid="footer-nav-numbers">{t.nav.numbers.toUpperCase()}</a>
          <a href="#manifesto" className="hover:text-thermal transition-colors duration-300" data-testid="footer-nav-manifesto">{t.nav.manifesto.toUpperCase()}</a>
          <a href="#contatti" className="hover:text-thermal transition-colors duration-300" data-testid="footer-nav-contact">{t.nav.contact.toUpperCase()}</a>
        </nav>
        <span data-testid="footer-legal">{t.footer.legal}</span>
      </div>

      <div className="relative z-10 border-t border-white/10 mt-16 md:mt-24 px-5 md:px-10 py-6 font-mono text-[10px] tracking-widest text-white/35 bg-background/80 backdrop-blur-sm" data-testid="footer-rights">
        {t.footer.rights}
      </div>
    </footer>
  );
};

export default Footer;
